{
  "version": 1,
  "asset_id": "48bdb044-e080-45a0-8871-34f5702a4c27",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/48bdb044-e080-45a0-8871-34f5702a4c27/inpakservice-home.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/48bdb044-e080-45a0-8871-34f5702a4c27/inpakservice-home.jpg",
  "original_filename": "inpakservice-home.jpg",
  "size": 928563,
  "content_type": "image/jpeg",
  "created_at": "2026-09-01T22:02:21Z"
}
